import { useCallback, useRef } from 'react'
import { useTrackedSWRKey } from '@systemeio/util'
import { BareFetcher } from 'swr'
import useSWRInfinite, { SWRInfiniteConfiguration, SWRInfiniteKeyLoader } from 'swr/infinite'

export const useInfiniteControlledSwr = <Data = any, Error = any>(
  getKey: SWRInfiniteKeyLoader,
  fetcher: BareFetcher<Data>,
  config?: SWRInfiniteConfiguration<Data, Error, BareFetcher<Data>>,
  isFetchAllowed: boolean = true,
) => {
  const firstKey = isFetchAllowed ? getKey(0, null) : null
  useTrackedSWRKey(firstKey)

  const aborter = useRef<AbortController | undefined>(undefined)
  const abort = useCallback(() => aborter.current?.abort(), [])

  const swrData = useSWRInfinite<Data>(
    isFetchAllowed ? getKey : () => null,
    args => {
      const url = Array.isArray(args) ? args[0] : args
      aborter.current = new AbortController()
      return fetcher?.(url, { signal: aborter.current.signal })
    },
    config,
  )

  return { ...swrData, abort }
}
